module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/dvd-98dea9fe2e5f90874f2269efd7fbcbd2.svg";